import { jsx } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
import { DocumentContext } from "../hooks/use-document-key";
import { Element } from "./Element";
const Document = memo(
  forwardRef(function Document2({ document }, ref) {
    return /* @__PURE__ */ jsx(DocumentContext.Provider, { value: document.key, children: /* @__PURE__ */ jsx(Element, { ref, element: document.rootElement }) });
  })
);
export {
  Document
};
//# sourceMappingURL=Document.js.map